<script>
import LoadingState from 'dashboard/components/widgets/LoadingState.vue';

export default {
  components: {
    LoadingState,
  },
  props: {
    config: {
      type: Array,
      default: () => [],
    },
    currentChat: {
      type: Object,
      default: () => ({}),
    },
    isVisible: {
      type: Boolean,
      default: false,
    },
    position: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      hasOpenedAtleastOnce: false,
      iframeLoading: true,
    };
  },
  computed: {
    dashboardAppContext() {
      return {
        conversation: this.currentChat,
        contact: this.$store.getters['contacts/getContact'](this.contactId),
        currentAgent: this.currentAgent,
      };
    },
    contactId() {
      return this.currentChat?.meta?.sender?.id;
    },
    currentAgent() {
      const { id, name, email } = this.$store.getters.getCurrentUser;
      return { id, name, email };
    },
  },
  watch: {
    isVisible() {
      if (this.isVisible) {
        this.hasOpenedAtleastOnce = true;
        if (this.iframeLoading) {
          clearTimeout(this._kisoftLoadTimer);
          this._kisoftLoadTimer = setTimeout(() => {
            this.iframeLoading = false;
          }, 8000);
        }
      }
    },
  },
  mounted() {
    window.addEventListener('message', this.triggerEvent);
    this._kisoftLoadTimer = setTimeout(() => {
      this.iframeLoading = false;
    }, 6000);
  },
  unmounted() {
    window.removeEventListener('message', this.triggerEvent);
    clearTimeout(this._kisoftLoadTimer);
  },
  methods: {
    triggerEvent(event) {
      if (!this.isVisible) return;
      if (event.data === 'chatwoot-dashboard-app:fetch-info') {
        this.onIframeLoad(0);
      }
    },
    getFrameId(index) {
      return `dashboard-app--frame-${this.position}-${index}`;
    },
    onIframeLoad(index) {
      // A possible alternative is to use ref instead of document.getElementById
      // However, when ref is used together with v-for, the ref you get will be
      // an array containing the child components mirroring the data source.
      // KISOFT: tira o loading ANTES de mandar o contexto (try/catch). Se o
      // JSON.stringify(dashboardAppContext) da conversa lancar erro, o spinner
      // 'Carregando aplicativo' travava pra sempre e o iframe nunca aparecia.
      this.iframeLoading = false;
      try {
        const frameElement = document.getElementById(this.getFrameId(index));
        if (frameElement && frameElement.contentWindow) {
          const eventData = { event: 'appContext', data: this.dashboardAppContext };
          frameElement.contentWindow.postMessage(JSON.stringify(eventData), '*');
        }
      } catch (e) {
        /* contexto opcional; nao bloqueia a exibicao do app */
      }
    },
  },
};
</script>

<!-- eslint-disable-next-line vue/no-root-v-if -->
<template>
  <div v-if="hasOpenedAtleastOnce" class="dashboard-app--container">
    <div
      v-for="(configItem, index) in config"
      :key="index"
      class="dashboard-app--list"
    >
      <LoadingState
        v-if="iframeLoading"
        :message="$t('DASHBOARD_APPS.LOADING_MESSAGE')"
        class="dashboard-app_loading-container"
      />
      <iframe
        v-if="configItem.type === 'frame' && configItem.url"
        :id="getFrameId(index)"
        :src="configItem.url"
        @load="() => onIframeLoad(index)"
      />
    </div>
  </div>
</template>

<style scoped>
.dashboard-app--container,
.dashboard-app--list,
.dashboard-app--list iframe {
  height: 100%;
  width: 100%;
}

.dashboard-app--list iframe {
  border: 0;
}
.dashboard-app_loading-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
}
</style>
